export class Broker {
    id: number;
    name: string;
    shortName: string;
    address: string;
    city: string;
    state: string;
    zipCode: number;
    country: string;
    phone: string;
    fax: string;
    cellular: string;
    email: string;
    url: string;
    disabled: boolean;
    addedBy: string;
    addedOn: string;
    updatedBy: string;
    updatedOn: string;
    code: string;
    isCallCenter: boolean;
    defaultAppAgentName: string;
    hasAccessToAllBrokers: boolean;
    hasCompanyOverride: boolean;
    isMWPUserAgent: boolean;
}

export class WorkingBroker {
    Id: number;
}